import * as types from '../constants/ActionTypes.js';
import { ROOT_URL } from '../constants/Config.js';

import axios from 'axios';

export function loadFavorites(data) {
  return dispatch => {
    dispatch({ type: types.LOAD_FAVORITES_START });
    return axios.get(`${ROOT_URL}/favorite/lists`, { params: data }).then((res) => {
      dispatch({ type: types.LOAD_FAVORITES_SUCCESS, payload: res.data });
    }).catch(error => {
      dispatch({ type: types.LOAD_FAVORITES_ERROR, payload: { error } });
    });
  };
}

export function addToFavorites(data, meta) {
  return dispatch => {
    dispatch({ type: types.ADD_TO_FAVORITES_START });
    return axios.post(`${ROOT_URL}/favorite/create`, data).then((res) => {
      dispatch({ type: types.ADD_TO_FAVORITES_SUCCESS, payload: data, meta });
    }).catch(error => {
      dispatch({ type: types.ADD_TO_FAVORITES_ERROR, payload: error });
    });
  };
}

export function removeFromFavorites(data, meta={}) {
  return dispatch => {
    dispatch({ type: types.REMOVE_FROM_FAVORITES_START });
    return axios.post(`${ROOT_URL}/favorite/delete`, data).then((res) => {
      dispatch({
        type: types.REMOVE_FROM_FAVORITES_SUCCESS,
        payload: data,
        meta: Object.assign(meta, {cancel: addToFavorites.bind(null, data, meta)})
      });
    }).catch(error => {
      dispatch({ type: types.REMOVE_FROM_FAVORITES_ERROR, payload: error });
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/favorites.js